<template>
  <v-select
    v-model="currentAppId"
    hide-details
    :items="apps"
    item-title="name"
    item-value="id"
    variant="plain"
    placeholder="Select App"
    class="mx-2"
  >
    <template #selection="{ item }">
      <v-avatar>
        <v-img :src="item.raw.logo || '/icon.png'" />
      </v-avatar>
      <div class="ml-4 text-h6">{{ item.raw.name }}</div>
    </template>
    <template #item="{ props, item }">
      <v-list-item
        v-bind="props"
        :prepend-avatar="item.raw.logo || '/icon.png'"
        :title="item.raw.name"
        :subtitle="item.raw.description"
      >
        <!--         <template #append>
         <v-chip v-if="item.raw.status" size="small" variant="outlined">
            {{ item.raw.status }}
          </v-chip>
        </template>  -->
      </v-list-item>
    </template>
  </v-select>
</template>

<script setup lang="ts">
import { useNavigationStore } from "~/stores/navigation"
import { storeToRefs } from "#imports"

const navigationStore = useNavigationStore()
const { currentAppId, apps } = storeToRefs(navigationStore)
</script>

<style scoped></style>
